import { IMAGE_MIME_TYPES } from '../constants/imageMimeTypes';
import { LEADING_DOT_REGEX } from '../constants/regex';
import { BYTES_PER_MEGABYTE } from 'features/shared/constants/fileSize.constants';

export const formatFileSize = (bytes = 0) => {
  if (bytes < BYTES_PER_MEGABYTE) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / BYTES_PER_MEGABYTE).toFixed(2)} MB`;
};

export const splitFileName = (fileName = '', fileType = '') => {
  if (!fileType) return fileName;
  return fileName.substr(0, fileName.length - fileType.length - 1);
};

export const downloadBufferAttachment = (buffer, FileType, FileName) => {
  if (!buffer) return;
  const fileType = (FileType || '').replace(LEADING_DOT_REGEX, '');
  const mimeType = IMAGE_MIME_TYPES[fileType.toLowerCase()] || 'application/octet-stream';
  const blob = new Blob([buffer], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileType ? `${FileName}.${fileType}` : FileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
